import styled from '../../../styles/theme';
import { CustomErrorStyled } from '../CustomErrorStyled';
import { rem } from 'polished';
import { publicAssets } from '@utils/url.utils';

export const CustomErrorStyledDS = styled(CustomErrorStyled)`
    background-size: cover;
    background-image: url('${publicAssets('/DS/ds_maintainance_bg.jpg')}');

    @media (min-width: ${rem(1440)}) {
        background-position: center center;
        background-image: url('${publicAssets('/DS/ds_maintenance_bg_wide.jpg')}');
    }

    .errorPage {
        &__content {
            background-color: rgba(26, 27, 27, 0.65);
        }

        &__title {
            color: ${({ theme }) => theme.colors.white};
        }

        &__description {
            color: ${({ theme }) => theme.colors.white};
        }

        &__link a {
            color: ${({ theme }) => theme.colors.coffeeDisabled};
            border-color: ${({ theme }) => theme.colors.coffee};
        }
    }
`;
